<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/notifications', text: 'notification_listTitle' },
                     {
                        url: '/notifications/' + data?.Id,
                        text: 'notification_viewTitle'
                     }]"></app-breadcrumbs>

    <ng-container *ngIf="data">
        <header class="content-header">
            <h1>
                {{'notification_title' | translate}} #{{data.Id}}
            </h1>
        </header>

        <div class="block-em">
            <div class="row">
                <div class="data-value col-md-6 col-lg">
                    <label>{{'notification_lblType' | translate}}</label>
                    <div>
                        {{data.Type}}
                        <div>({{data.Template}})</div>
                    </div>
                </div>

                <div class="data-value col-md-6 col-lg">
                    <label>{{'notification_lblSender' | translate}}</label>
                    <div>{{data.Sender}}</div>
                </div>

                <div class="data-value col-md-6 col-lg">
                    <label>{{'notification_lblChannels' | translate}}</label>
                    <div>
                        <div *ngFor="let n of channels; let i = index">
                            {{'notification_channel' + n.name | translate}}
                            <span class="text-danger" *ngIf="n.required"> *</span>
                        </div>
                    </div>
                </div>

                <div class="data-value col-md-6 col-lg">
                    <label>{{'notification_lblFinished' | translate}}</label>
                    <div>
                        <div *ngIf="data.Finished">{{data.Finished | appDate:'datetime'}}</div>
                        <app-notification-status [value]="data.Status"></app-notification-status>
                    </div>
                </div>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notification_lblSubject' | translate}}</label>
            <div>
                <div class="lang-value">
                    <div>(LV)</div>
                    <div>
                        <ng-container *ngIf="data.SubjectLV; else noValue">
                            {{data.SubjectLV}}
                        </ng-container>
                    </div>
                </div>

                <div class="lang-value">
                    <div>(EN)</div>
                    <div>
                        <ng-container *ngIf="data.SubjectEN; else noValue">
                            {{data.SubjectEN}}
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notification_lblMessage' | translate}}</label>
            <div>
                <div class="lang-value">
                    <div>(LV)</div>
                    <ng-container *ngIf="data.MessageLV; else noValue">
                        <span [innerHTML]="data.MessageLV | safeHtml"></span>
                    </ng-container>
                </div>

                <div class="lang-value">
                    <div>(EN)</div>
                    <ng-container *ngIf="data.MessageEN; else noValue">
                        <span [innerHTML]="data.MessageEN | safeHtml"></span>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="data-value">
            <label>{{'notification_lblShortMessage' | translate}}</label>
            <div>
                <div class="lang-value">
                    <div>(LV)</div>
                    <div>
                        <ng-container *ngIf="data.ShortMessageLV; else noValue">
                            {{data.ShortMessageLV}}
                        </ng-container>
                    </div>
                </div>

                <div class="lang-value">
                    <div>(EN)</div>
                    <div>
                        <ng-container *ngIf="data.ShortMessageEN; else noValue">
                            {{data.ShortMessageEN}}
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <section>
            <h5>{{'notification_recipients' | translate}}</h5>

            <div class="row">
                <div class="col">
                    <div class="form-field">
                        <label class="form-label">{{'notification_lblRecipient' | translate}}</label>
                        <input class="form-control"
                               name="recipientFilterName"
                               [(ngModel)]="recipientFilterValues.search"
                               (input)="searchRecipients($event)"
                               maxlength="50">
                    </div>
                </div>

                <div class="col" *ngFor="let n of allChannels">
                    <div class="form-field">
                        <label class="form-label">{{'notification_channel' + n | translate}}</label>
                        <app-select name="recipientFilterChannel_{{n}}"
                                    [(ngModel)]="recipientFilterValues.channels[n]"
                                    [options]="options.requestStatus"
                                    [multiple]="true"
                                    [displayProperty]="'text'"
                                    [valueProperty]="'value'"
                                    [disabled]="!isChannelAvailable(n)"
                                    (selectionChange)="filterRecipients()"></app-select>
                    </div>
                </div>
            </div>

            <app-table [rows]="recipientRows" [columns]="recipientColumns">
                <ng-template #rowTemplate let-row>
                    <tr>
                        <td>
                            <div>
                                {{row.recipient.Name}} {{row.recipient.Surname}}
                            </div>
                            <div class="text-sub">{{row.recipient.Upn}}</div>
                        </td>
                        <td>{{'notification_language' + row.recipient.Language | translate}}</td>
                        <td *ngFor="let c of row.channels">
                            <ng-container *ngIf="isFinal">
                                <app-notification-request-status *ngIf="c.isAvailable && !c.isRejected"
                                                                 [value]="c.status"
                                                                 [date]="c.sent"
                                                                 [error]="c.error"></app-notification-request-status>

                                <span class="badge text-bg-light" *ngIf="c.isAvailable && c.isRejected">
                                    {{'notification_requestRejected' | translate}}
                                </span>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
            </app-table>
        </section>

        <section>
            <h5>{{'notification_stats' | translate}}</h5>
            <div class="block-em mt-0">
                <div class="row">
                    <div class="col-sm data-value" *ngFor="let n of stats">
                        <label>{{'notification_channel' + n.channel | translate}}</label>
                        <div>
                            <div>{{'notification_requestApproved' | translate}}: <span class="text-success">{{n.approved}}</span></div>
                            <div>{{'notification_requestRejected' | translate}}: <span class="text-secondary">{{n.rejected}}</span></div>
                            <div>{{'notification_requestFailed' | translate}}: <span class="text-danger">{{n.failed}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </ng-container>

    <div class="form-actions">
        <button class="btn btn-outline" type="button" [routerLink]="['/notifications'] | localize">
            {{'close' | translate}}
        </button>
    </div>
</div>

<ng-template #noValue>{{'undefined' | translate}}</ng-template>
